import {
  Alert,
  Box,
  Button,
  Container,
  Group,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { AppShell } from '../../app-shell';
import { getErrorMessage } from './utils';

export const RouteErrorState = ({ error, reset }: ErrorComponentProps) => {
  const message = getErrorMessage(error);

  return (
    <AppShell>
      <Container size="md" py={80} px="xl">
        <Box>
          <Stack spacing="lg">
            <div>
              <Title order={2}>Something went wrong</Title>
              <Text mt="xs" c="dimmed">
                The page failed to load. Try again, or reload the application if
                the problem persists.
              </Text>
            </div>

            <Alert color="red" title="Error details" variant="light">
              <Text>{message}</Text>
            </Alert>

            <Group>
              <Button onClick={reset}>Try again</Button>
              <Button
                variant="default"
                onClick={() => window.location.reload()}
              >
                Reload app
              </Button>
            </Group>
          </Stack>
        </Box>
      </Container>
    </AppShell>
  );
};
